import * as cookiesService from 'services/cookies'
import { useQuery } from 'react-query'
import { fetchMySubscriptions } from 'services/subscriptions'
import { SubscriptionStatus } from 'services/programming'

export function useMyActiveSubscriptions() {
  const accessToken = cookiesService.getAccessToken()
  const subscriptionsQuery = useQuery(
    'subscriptions',
    () =>
      fetchMySubscriptions().then((s) =>
        s.filter(
          (x) =>
            x.status === SubscriptionStatus.active &&
            new Date() < new Date(x.expiryDate),
        ),
      ),
    { enabled: !!accessToken },
  )

  if (subscriptionsQuery.isSuccess) {
    return subscriptionsQuery.data
  }

  return null
}

export function useAllSubscriptions() {
  const accessToken = cookiesService.getAccessToken()
  const subscriptionsQuery = useQuery(
    'subscriptions',
    () => fetchMySubscriptions(),
    { enabled: !!accessToken },
  )

  if (subscriptionsQuery.isSuccess) {
    return subscriptionsQuery.data
  }

  return null
}
